import { observable, action, flow, computed, toJS } from 'mobx';
import { cloneDeep } from 'lodash';
import Stores from 'config/Stores';
import { isHasRouteAuth } from 'utils/authUtil';
import { routeAuthCodeMap } from 'utils/constants';
import Serv from './ProductListServ';
import { t } from 'config/language/context';

const SEARCH_TYPE = {
  COURSE: 'SEARCH_TYPE_COURSE',
  TOOL_VIDEO: 'SEARCH_TYPE_TOOL_VIDEO'
};

const defaultFilterObj = {
  // 分类
  catalog: [],
  // 品牌
  brand: [],
  // 标签
  tag: []
};

const defaultListData = {
  data: null,
  isLoading: false,
  hasPullToRefresh: true,
  pageNum: 1,
  pages: 1
};

class ProductListMod {
  @observable tabIndex = 0; // 0-综合 1-销量 2-价格

  @observable hasRequest = false; // 是否已请求

  @observable scrollTop = 0; // 滚动高度

  @observable isList = false; // 展示内容是否为列表 （列表or橱窗）

  // @observable sortType = 1; // 排序方式 1-上架时间，2-销量，3-价格
  @observable sortType = 4; // 排序方式 4-综合，2-销量，3-价格

  @observable sortOrder = 'DESC'; // ASC-升序，DESC-倒序 (注意，是大写字母)

  @observable filterObj = defaultFilterObj;

  @observable dirId = ''; // 类目id

  @observable parentId = ''; // 类目分级id

  @observable catalogList = []; // 分类列表

  @observable brandList = []; // 获取品牌列表

  @observable tagList = []; // 获取标签列表

  @observable listData = cloneDeep(defaultListData); // 产品列表数据

  @observable keyword = ''; // 搜索关键字盒子展示的keyWord

  @observable itemIdList = []; // 产品id列表

  @observable itemProperties = '';

  @observable distributionRatio = '';

  @observable courseList = [];

  @observable tabList = [];

  @observable infinite = true;

  // 浏览商品成功之后的返回值
  coninSuccessData = {};

  // 是否来自甄选商城
  isFromSelectMall = false;

  // 三生豆倒计时计时器
  timerInterVal = null;

  // 三生豆倒计时计时器
  eyeTimeUpdateInterval = null;

  @observable countdown = 0;

  lookValue = '';

  @observable showCountDown = false;

  @observable showGetCoinModal = false;

  @observable integrationStart = ''; // 积分区间

  @observable integrationEnd = ''; // 积分区间

  @observable scoreRange = 0; // 0：全部 1：仅当前用户积分 2自定义区间",

  @observable searchParams = {}; // searchParams --> priceRangeS, priceRangeE, bvRangeS, bvRangeE, integralRangeS, integralRangeE

  @observable activityList = []; // 活动列表

  @observable otherList = []; // 其它列表

  @action
  changeModState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @action
  changeState(obj) {
    console.log('objobj', obj);
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  defaultFilterObj = {
    // 分类
    catalog: [],
    // 品牌
    brand: [],
    // 标签
    tag: []
  };

  // 登录状态下有培训中心权限点的展示课程和工具流
  @computed
  get showLearningCenter() {
    return (
      !Stores.AppMod.token || (Stores.AppMod.token && isHasRouteAuth(routeAuthCodeMap.EXPAND_TRAIN))
    );
  }

  // 获取产品列表
  getProductList = flow(function* (pageNum = 1) {
    let {
      dirId,
      sortType,
      sortOrder,
      keyword,
      listData,
      itemIdList,
      filterObj: { catalog, brand, tag },
      itemProperties,
      distributionRatio
    } = this;

    this.listData.isLoading = true;
    // if (pageNum === 1) {
    //   this.listData.data = [];
    // }

    let params = {
      // 前端类目id集合
      frontDirIdList: catalog,
      // 品牌id集合
      brandIdList: brand,
      // 角标id集合
      cornerIdList: tag,
      // 用于区分显示的文案是类目还是搜索内容
      keyword: dirId ? '' : keyword,
      // 排序方式 1:时间 2:销量 3:价格 4:综合(默认)
      sortType,
      // 排序升降序：ASC:升序；DESC：降序
      sortOrder,
      // 是否有库存
      inStock: 1,
      // 产品id列表
      itemIdList,
      itemProperties,
      distributionRatio,
      ...this.searchParams
    };

    // 甄选商城商品搜索
    if (this.isFromSelectMall) {
      params.isSelectioItem = 1;
      params.scoreRange = this.scoreRange;
    }

    if (this.scoreRange == 2) {
      params.scoreRange = 2;
      params.integrationStart = this.integrationStart ? +this.integrationStart : '';
      params.integrationEnd = this.integrationEnd ? +this.integrationEnd : '';
      'integralRangeS' in params && delete params.integralRangeS;
      'integralRangeE' in params && delete params.integralRangeE;
    }

    try {
      const { data = {} } = yield Serv.getProductList({ pageSize: 10, pageNum }, params);
      this.listData.isLoading = false;
      if (pageNum !== 1) {
        const arr = listData.data || [];
        this.listData.data = arr.concat(data.list || []);
      } else {
        this.listData.data = data.list || [];
      }
      console.log('=============', this.listData.data.length);

      // 重置页数等信息
      this.listData.pageNum = data.pageNum;
      this.listData.pages = data.pages;

      if (!this.hasRequest) {
        // 品牌
        this.brandList = data.brandList || [];

        // 角标/标签
        if (data.cornerMarkerList) {
          this.tagList = data.cornerMarkerList.filter((item) => `${item.status}` == '1');
        }

        // 分类
        if (!this.parentId && data.catalogList) {
          this.catalogList = data.catalogList.filter((item) => `${item.status}` == '1');
        }
      }
      // 神策数据发送
      if (params.keyword) {
        window.sensors.track('search', {
          key_word: params.keyword,
          has_result: data.list && data.list.length > 0,
          source: 'H5' // 来源
        });
      }
      let saList = [];
      if (data.list) {
        data.list.map((item) => {
          saList.push(item.id || '');
        });
      }

      window.sensors.track('productList', {
        item_list: JSON.stringify(saList) || '',
        category: JSON.stringify(catalog) || '',
        brand: JSON.stringify(brand) || ''
      });
    } catch (error) {}

    this.hasRequest = true;
  });

  // 获取商品/课程/工具流列表个数
  getCategoryCount = flow(function* () {
    try {
      let {
        dirId,
        sortType,
        sortOrder,
        keyword,
        listData,
        itemIdList,
        filterObj: { catalog, brand, tag },
        itemProperties,
        distributionRatio
      } = this;

      const esBrowseItemReqDto = {
        // 前端类目id集合
        frontDirIdList: catalog,
        // 品牌id集合
        brandIdList: brand,
        // 角标id集合
        cornerIdList: tag,
        // 用于区分显示的文案是类目还是搜索内容
        keyword: dirId ? '' : keyword,
        // 排序方式 1:时间 2:销量 3:价格 4:综合(默认)
        sortType,
        // 排序升降序：ASC:升序；DESC：降序
        sortOrder,
        // 是否有库存
        inStock: 1,
        // 产品id列表
        itemIdList,
        itemProperties,
        distributionRatio
      };

      // 甄选商城商品搜索
      if (this.isFromSelectMall) {
        esBrowseItemReqDto.isSelectioItem = 1;
      }

      const toolVideoReqDto = {
        pageNum: 1,
        pageSize: 10,
        filter: keyword,
        sortType: 2
      };

      const courseFilter = keyword;

      const params = {
        esBrowseItemReqDto,
        toolVideoReqDto,
        courseFilter
      };

      const { data, resultCode, resultMsg } = yield Serv.getCategoryCount(params);
      const activityResult = yield Serv.searchActivityZone({
        searchKeyword: keyword
      });
      const otherResult = yield Serv.searchEnter({
        searchKeyword: keyword
      });
      // const deleteIndex = (index) => {
      //   let findIndex = this.tabList.findIndex((item) => item.index == index);
      //   if (findIndex > -1) this.tabList.splice(findIndex, 1);
      // };
      if (resultCode == 0) {
        const myTab = [];
        if (data.itemExist) {
          myTab.push({
            text: '商品',
            cureet: 'activity1',
            index: 0
          });
        }
        if (
          data.hotCourseExist &&
          this.showLearningCenter &&
          Stores.AppMod.searchAuthList.includes(SEARCH_TYPE.COURSE)
        ) {
          myTab.push({
            text: '课程',
            cureet: 'activity2',
            index: 1
          });
        }
        if (
          data.hotVideoExist &&
          this.showLearningCenter &&
          Stores.AppMod.searchAuthList.includes(SEARCH_TYPE.TOOL_VIDEO)
        ) {
          myTab.push({
            text: '工具流',
            cureet: 'activity3',
            index: 2
          });
        }

        if (activityResult && activityResult.data && activityResult.data.length > 0) {
          myTab.unshift({
            text: '活动',
            cureet: 'activity4',
            index: 3
          });
          this.activityList = activityResult.data;
        }

        if (otherResult && otherResult.data && otherResult.data.length > 0) {
          myTab.push({
            text: '其它',
            cureet: 'activity5',
            index: 4
          });
          this.otherList = otherResult.data;
        }
        this.tabList = myTab;
      }
    } catch (err) {
      console.log(err);
    }
  });

  // 修改筛选对象
  @action
  changeFilterObj(key, value) {
    const obj = JSON.parse(JSON.stringify(this.filterObj));

    if (Array.isArray(value)) {
      obj[key] = value;
    } else {
      const arr = obj[key];
      const index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      } else {
        obj[key].push(value);
      }
    }

    this.filterObj = obj;
  }

  @action
  resetFilterObj() {
    this.filterObj = this.defaultFilterObj;
  }

  // 获取分类列表
  getCatalogList = flow(function* (id) {
    try {
      const { data } = yield Serv.getCatalogList({
        parentId: id,
        dirUsage: 'front'
      });
      let result = [];
      if (data) {
        result = data.filter((item) => item.status === 1);
      }
      this.catalogList = result;
    } catch (error) {}
  });

  /**
   * 商品浏览任务-向上更新浏览时间 返回更新值
   * params:参数
   */
  eyeTimeUpdate = flow(function* (params) {
    try {
      const { data } = yield Serv.eyeTimeUpdate(params);
      if (data) {
        return data;
      }
    } catch (e) {}
  });

  /**
   * 完成行为相关参数上报
   * params:参数
   */

  finishTask = flow(function* (params) {
    try {
      const { data } = yield Serv.finishTaskReport(params);
      if (data) {
        this.coninSuccessData = data;
        return data;
      }
    } catch (e) {
      console.log('error', e);
    }
  });

  searchActivityZone = flow(function* (params) {
    try {
      const { data } = yield Serv.searchActivityZone(params);
      if (data && data.length > 0) {
        this.tabList = [
          {
            text: '活动',
            cureet: 'activity1',
            index: 1
          },
          {
            text: '专题',
            cureet: 'activity1',
            index: 2
          }
        ];
      }
    } catch (e) {
      console.log('error', e);
    }
  });

  @action
  resetBeanData() {
    if (this.timerInterVal) {
      clearInterval(this.timerInterVal);
    }
    if (this.eyeTimeUpdateInterval) {
      clearInterval(this.eyeTimeUpdateInterval);
    }
    this.timerInterVal = null;
    this.eyeTimeUpdateInterval = null;
    this.countdown = 0;
    this.lookValue = '';
    this.showGetCoinModal = false;
    this.showCountDown = false;
  }

  @action
  resetData() {
    this.tabList = [];
    this.tabIndex = 0;
    this.isList = false;
    this.sortType = 4;
    this.sortOrder = 'DESC';
    this.filterObj = defaultFilterObj;
    this.dirId = '';
    this.parentId = '';
    this.catalogList = [];
    this.brandList = [];
    this.tagList = [];
    this.listData = defaultListData;
    this.keyword = '';
    this.hasRequest = false;
    this.scrollTop = 0;
    this.itemIdList = [];
    this.itemProperties = '';
    this.distributionRatio = '';
    this.courseList = [];
    if (this.timerInterVal) {
      clearInterval(this.timerInterVal);
    }
    if (this.eyeTimeUpdateInterval) {
      clearInterval(this.eyeTimeUpdateInterval);
    }
    this.timerInterVal = null;
    this.eyeTimeUpdateInterval = null;
    this.countdown = 0;
    this.lookValue = '';
    this.showGetCoinModal = false;
    this.showCountDown = false;
    this.defaultFilterObj = {
      // 分类
      catalog: [],
      // 品牌
      brand: [],
      // 标签
      tag: []
    };
  }
}

const productListMod = new ProductListMod();
export default productListMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/ProductList/ProductListMod.js